/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/jquery.flot/jquery.flot.d.ts" />
/// <reference path="../../customtypings/chart.js/index.d.ts" />

namespace Application.Directives {
    'use strict';

    declare type MvpDetailsTableDirectiveFactoryCb = () => MvpDetailsTableDirective;
    // import Utils = Application.Common.Utils;

    interface IMvpDetailsTableDirectiveScopeDef {
        device: string;
        datalinks: any;
    }

    interface IMvpDetailsTableDirectiveScope extends ng.IScope {
        device: string,
        name: string;
        options: Chart.ChartOptions;
        datasetOverride: any;
        value: number | string | boolean;
        list: string;
        format: string;
        datalinks: any;
        links: any;
        fields: string[];
        devicesIdsNodesEnum: any;

        valueToShow: number | string | boolean | string[];
        fullValue: string;
        isList: () => boolean;
        isEmpty: () => boolean;
        isHidden: () => boolean;
        copyToClipBoard: (elementId: string) => void;
        copyToVLC: (elementId: string) => void;
    }

    const mvpAgileCollumns = [
        "Link Nr",
        "Status",
        "Bit rate",
        "Mbps",
        "RF Levels",
        "dBm",
    ];

    const mvpOI24Collumns = [
        "Link Nr",
        "Status",
        "RT Time",
        "ms",
        "Packet Losses",
        "%",
    ];

    export class MvpDetailsTableDirective implements ng.IDirective {
        public static $name: string = 'mvpDetailsTable';

        public restrict: string = 'E';
        public replace: boolean = true;
        public templateUrl: string = 'decorators/mvp-details-table-directive.html';
        public scope: IMvpDetailsTableDirectiveScopeDef = {
            device: '=',
            datalinks: '=?',
        };
        public devicesIdsNodesEnum: any = {
            MVP_AGILE: 7,
            MVP_O4: 5,
            MVP_O2: 4,
            MVP_IO: 3,
          }

        public link: (scope: IMvpDetailsTableDirectiveScope, $element: JQuery, attrs: ng.IAttributes) => void;

        /**
         * Factory for the directive
         */
        public static Factory(): MvpDetailsTableDirectiveFactoryCb {
            let directive: MvpDetailsTableDirectiveFactoryCb = () => {
                return new MvpDetailsTableDirective();
            };
            directive.$inject = [];
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            MvpDetailsTableDirective.prototype.link = (scope: IMvpDetailsTableDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                scope.options =
                {
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            display: false,
                        }],
                        yAxes: [{
                            display: false,
                        }]

                    },
                    elements: {
                        line: {
                            borderWidth: 2,
                            borderColor: '#4475c8',
                            backgroundColor: '#4475c8',
                            fill: true,
                        },
                        point: {
                            radius: 0,
                        },
                    },
                }

                scope.links = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

                scope.$watch('datalinks', (links: any, oldLinks: any) => {
                    if (links !== undefined) {
                        this.updateDataLinks(links, scope);
                    }
                });

                scope.$watch('device', (links: any, oldLinks: any) => {
                    const recivers: any = [this.devicesIdsNodesEnum.MVP_O4,this.devicesIdsNodesEnum.MVP_O2,this.devicesIdsNodesEnum.MVP_IO];
                    if (+scope.device === this.devicesIdsNodesEnum.MVP_AGILE) {
                        scope.fields = mvpAgileCollumns;
                    } else if (recivers.includes(+scope.device)) {
                        scope.fields = mvpOI24Collumns;
                    } else {
                        scope.fields = [];
                    }
                });

                scope.devicesIdsNodesEnum = {
                    MVP_AGILE: 7,
                    MVP_O4: 5,
                    MVP_O2: 4,
                    MVP_IO: 3,
                }

            }
        }

        /**
         * If the canvas data is not initialized in the current index, create new graph canvas with starting data at zero, if is initialized, append value and shift array
         * @param arr array of data
         * @param index array position of data process
         * @param fieldData current field to be evaluated in graph
         * @param fieldLabels graph labels
         * @param value final value to append to the canvas
         */
        private refreshDataToCanvas(arr: any, index: number, fieldData: string, fieldLabels: string, value: any) {
            if (arr[index - 1][fieldData] === undefined) {
                arr[index - 1][fieldData] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                arr[index - 1][fieldLabels] = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""];
            }
            arr[index - 1][fieldData].push(value);
            arr[index - 1][fieldData].shift();
        }

        /**
         * Iterate in data when is updated from backend (pulling event)
         * @param dataLinks Updated data from backend
         * @param scope Angular Scope
         */
        private updateDataLinks(dataLinks: any, scope: IMvpDetailsTableDirectiveScope) {
            const matcherLink = (+scope.device === this.devicesIdsNodesEnum.MVP_AGILE) ? /(connection\d)/ : /(link\d)/;
            const matcherLinkField = (+scope.device === this.devicesIdsNodesEnum.MVP_AGILE) ? /(connection\d+)/ : /(link\d+)/;
            const links = Object.keys(dataLinks)
                .filter(key => key.match(matcherLink))
                .reduce((arr, key) => {
                    
                    let value = dataLinks[key];
                    const index: number = +key.match(/(\d+)/)[0];
                    const field: string = key.replace(key.match(matcherLinkField)[0], '');

                    if (field === 'Bitrate') {
                        value = this.bitsToMpbs(+value);
                        this.refreshDataToCanvas(arr, index, 'bitRateData', 'bitRateLabels', value);
                    }

                    if (field === 'RFLevels') {
                        this.refreshDataToCanvas(arr, index, 'rfLevelData', 'rfLevelLabels', value);
                    }

                    if (field === 'RTT') {
                        this.refreshDataToCanvas(arr, index, 'rttData', 'rttLabels', value);
                    }

                    if (field === 'PacketLosses') {
                        this.refreshDataToCanvas(arr, index, 'packetLossesData', 'packetLossesLabels', value);
                    }

                    arr[index - 1]['index'] = index;
                    arr[index - 1][field] = value;

                    return arr;

                }, scope.links);
            scope.links = links;
        }

        /**
         * convert bit in Megabytes
         * @param bits value in bits
         */
        private bitsToMpbs(bits: number): number {
            if (bits === null) // tslint:disable-line
                return null; // tslint:disable-line
            let value: number = parseFloat((bits / 1000000).toFixed(2));
            return isNaN(value) ? 0 : value;
        }
    }
}